<template>
  <CContainer>
    <h3>Formulario Contrato de Arrendamiento</h3>
    <CCard class="mt-4">
            <CCardBody>
              <CForm class="p-2">
                <CRow>
                  <CCol col="sm-12">
                    <CAutocomplete
                      label="Cliente:"
                      required
                      :options="directory"
                      :value.sync="rentContract['directorio']"
                      @update-search="value => getListDirectory(value)"
                      @update:input="newValue => {
                        rentContract['directorio'] = newValue;
                        validate();
                      }">
                    </CAutocomplete>
                  </CCol>
                  <CCol col="sm-12">
                    <CAutocomplete
                      label="Comercial: "
                      required
                      :options="personal"
                      :value.sync="rentContract['personal']"
                      @update:input="newValue => {
                        rentContract['personal'] = newValue;
                        validate();
                      }">
                    </CAutocomplete>
                  </CCol>
                  <CCol col="sm-3">
                    <label class="text-muted font-weight-bold">
                      Fecha Emisi&oacute;n:
                    </label>
                    <DatePicker 
                      type="date" 
                      v-model="rentContract['fecha_Emision']" 
                      value-type="YYYY-MM-DD" 
                      format="DD/MM/YYYY" 
                      placeholder="dd/mm/aaaa"
                      @close="validate" />
                  </CCol>
                  <CCol col="sm-3">
                    <label class="text-muted font-weight-bold">
                      Fecha Vencimiento:
                    </label>
                    <DatePicker
                      type="date"
                      v-model="rentContract['fecha_Vencimiento']"
                      value-type="YYYY-MM-DD"
                      format="DD/MM/YYYY"
                      placeholder="dd/mm/aaaa" />
                  </CCol>
                  <CCol col="sm-3">
                    <CInput
                      label="Orden Compra:"
                      type="text"
                      addLabelClasses="text-muted font-weight-bold"
                        :value.sync="rentContract['orden_Compra']">
                    </CInput>
                  </CCol>
                  <CCol col="sm-3">
                      <CSelect 
                        label="Tipo Contrato: "
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="rentContract['tipo_Contrato']"
                        :options="[
                          { value: 'A', label: 'Abierto'},
                          { value: 'C', label: 'Cerrado'}
                        ]"
                        @change="() => validate()"
                      />
                    </CCol>
                </CRow>

                <CRow>
                    <CCollapse :show="rentContract['tipo_Contrato'] === 'C'">
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Aseguradora: "
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['aseguradora']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['aseguradora'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Número de póliza: "
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['numero_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['numero_Poliza'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Fecha póliza:"
                              type="date"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['fecha_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()"
                              :isValid="rentContract['tipo_Contrato'] === 'A' ? undefined : rentContract['fecha_Poliza'].length > 0">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <CInput
                              label="Vigencia póliza:"
                              type="date"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="rentContract['vigencia_Poliza']"
                              :disabled="rentContract['tipo_Contrato'] === 'A'"
                              @change="() => validate()">
                          </CInput>
                      </CCol>
                      <CCol sm="6" class="d-inline-block">
                          <!-- <CInput
                              label="Valor Asegurado:"
                              type="text"
                              addLabelClasses="text-muted font-weight-bold"
                              :value.sync="assuredValue">
                          </CInput> -->
                          <div class="form-group" role="group">
                              <label for="assuredValue" class="text-muted font-weight-bold">Valor Asegurado:</label>
                              <input type="text"
                                  id="assuredValue"
                                  class="form-control" 
                                  v-mask="currencyMask"
                                  v-model="assuredValue"
                                  :disabled="rentContract['tipo_Contrato'] === 'A'"
                                  :class="rentContract['tipo_Contrato'] === 'A' ? '' : rentContract['valor_Asegurado'] > 0 ? 'is-valid' : 'is-invalid'"
                                  @change="(value) => {
                                    setRentContractAssuredValue(value);
                                    validate();
                                  }"
                              />
                          </div>
                      </CCol>
                    </CCollapse>
                    <CCol col="sm-6">
                      <span class="text-muted font-weight-bold">Estado:</span>
                      <CSwitch 
                        class="align-middle mx-2"
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="rentContractStatus"
                        @update:checked="(value) => {
                          rentContract['estado'] = value ? 'A' : 'I'
                        }"/>
                      <span class="font-weight-bold">{{ rentContract["estado"] === "A" ? "Activo" : "Inactivo" }}</span>
                    </CCol>
                </CRow>
              </CForm>
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify-content-center">
                <CButton
                  color="success"
                  class="mr-2"
                  :class="isValidForm ? '' : 'disabled'"
                  :disabled="!isValidForm"
                  @click="saveRentContractData()">
                  <CIcon name="cil-check-circle" class="mr-2" />
                  <span class="align-middle">Guardar</span>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="mr-2"
                  @click="() => {
                    $router.push({ path: rootPath });
                  }">
                  <CIcon name="cil-x-circle" class="mr-2" />
                  <span class="align-middle">Cancelar</span>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>

    <LoadingCover v-show="loading" />
  </CContainer>
</template>
<script>
  import "vue2-datepicker/index.css";
  import { ref } from "vue";
  import DatePicker from "vue2-datepicker"
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'    
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import CAutocomplete from "@/components/containers/CAutocomplete";

  import CONSTANTS from "@/constants";
  import { 
    formatter, 
    toBase64 
  } from "@/general";
  import {
    searchDirectorio,
    dataListPersonal,
    obtenerDirectorio
  } from "@/api";
  import { crudContratoArrendamiento } from "@/apis/rents";
    
  const currencyMask = createNumberMask({
    prefix: '$ ',
    integerLimit: 12,
    allowDecimal: true,
    decimalSymbol: ',',
    thousandsSeparatorSymbol: '.',
    includeThousandsSeparator: true,
    allowNegative: false,
  });

  export default {
    name: "RentContractForm",
    data() {
      return {
        CONSTANTS,
        formatter,
        currencyMask,
        loading: false,
        isCreate: false,
        isValidForm: false,
        directory: [],
        personal: [],
        rentContract: {
          directorio: "",
          personal: "",
          fecha_Emision: "",
          fecha_Vencimiento: "",
          orden_Compra: "",
          tipo_Contrato: "A",
          aseguradora: "",
          numero_Poliza: "",
          fecha_Poliza: "",
          vigencia_Poliza: "",
          valor_Asegurado: "0",
          estado: "A"
        },
        rentContractStatus: true,
        rentContractId: "",
        assuredValue: 0
      }
    },
    components: {
      DatePicker,
      CAutocomplete,
      LoadingCover
    },
    methods: {
      toBase64,
      async getListDirectory(value) {
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value)

            this.directory = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            });
          } catch (error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: 'Error al cargar datos.',
              show: 5
            });
          }
        }
      },
      async getListPersonal() {
        try {
          const dataPersonal = await dataListPersonal(this, "V")

          this.personal = dataPersonal.map(item => {
            return {
              value: item.id_Personal,
              label: `${item.nombre_Empleado} - ${item.identificacion}`
            }
          });
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        }
      },
      async getDirectory(idDirectory) {
        try {
          const directory = await obtenerDirectorio(this, idDirectory);

          return [{
            value: directory.id_Directorio,
            label: `${directory.empresa} - ${directory.identificacion}`
          }];
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo cargar los datos del Cliente. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        }
      },
      validate() {
        const staticRequiredFields = ["directorio", "personal", "fecha_Emision"];
        const requiredFields = this.rentContract['tipo_Contrato'] === 'C' ? staticRequiredFields.concat(['aseguradora', 'numero_Poliza', 'fecha_Poliza', 'valor_Asegurado']) : staticRequiredFields
        this.isValidForm = requiredFields.reduce((acc, key) => {
          const tempVar = this.rentContract[key] ? this.rentContract[key] : ""
          this.rentContract[key] = tempVar
          return acc && (this.rentContract[key].length > 0)
        }, true)
      },
      async getRentContractData(contractId) {
        this.loading = true;

        try {
          const response = await crudContratoArrendamiento(this, "read", contractId);
          const directoryId = response["directorio"];

          this.directory = await this.getDirectory(directoryId);

          Object.keys(this.rentContract).forEach(key => {
            this.rentContract[key] = response[key]
          });

          Object.keys(this.rentContract).forEach(key => {
            console.log("Key ", key, " - Value ", this.rentContract[key]);
          });

          this.validate();
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo cargar los datos del Contrato de Arrendamiento. Error ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async saveRentContractData() {
        this.loading = true

        try {
          const processData = {}

          Object.keys(this.rentContract).forEach(key => {
            this.rentContract[key] ? processData[key] = this.rentContract[key] : undefined
          })

          if (this.isCreate) {
            const response = await crudContratoArrendamiento(this, "create", null, processData);

            this.rentContractId = response.id_ContratoArrendamiento.replaceAll("-", "")
          } else {
            await crudContratoArrendamiento(this, "update", this.rentContractId, processData);
          }

          CONSTANTS.configSimpleConfirm.confirmButtonText = "Agregar"
          CONSTANTS.configSimpleConfirm.confirmButtonColor = "green"

          this.$confirm("¿Desea agregar productos al contrato de arrendamiento?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
            this.$router.push({ path: `${this.rootPath}/${this.rentContractId}/productosarrendamiento/agregar` })
          }).catch(() => {
            this.$router.push({ path: this.rootPath });

            this.$store.commit('setAlert', {
              color: "success",
              message: 'Acción exitosa',
              show: 5
            })
          })
        } catch (error) {
          console.log(error);
          
          this.$store.commit('setAlert', {
            color: "danger",
            message: this.create ? CONSTANTS.messages.notDoneAdd : CONSTANTS.messages.notDoneEdit,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      setRentContractAssuredValue(v) {
        this.rentContract['valor_Asegurado'] = v.target.value.replace("$", "").replaceAll(".", "").replaceAll(",", ".")
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      let action;
      const params_id = this.$router.currentRoute.params.id;

      this.rootPath = this.$router.currentRoute.fullPath;

      if (params_id === undefined || params_id === null) {
        action = this.rootPath.split("/").at(-1);
        this.isCreate = action === "agregar" ? true : false;
      } else {
        this.rootPath = this.rootPath.replace(`/${params_id}`, "");
        action = this.rootPath.split("/").at(-1);
      }
      
      this.rootPath = this.rootPath.replace(`/${action}`, "");

      await this.getListPersonal();

      if (!this.isCreate) {
        this.getRentContractData(params_id);
      }
    }
  }
</script>
